<template>
  <div class="sidebar-pinned ">
    <Navbar/>

    <main class="admin-main">
    <!--site header begins-->

   <section class="admin-content">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-grid" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Hello, {{auth_user.firstname}}</h4>
              <small style="opacity: .8;">Your plan, dependents and wallet overview</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <div class="row" v-if="myplan.length < 1">
          <div class="col-md-6 mb-3">
            <div class="alert alert-border-warning alert-dismissible fade show" role="alert">
              <div class="d-flex">
                <div class="icon">
                  <i class="icon mdi mdi-alert-circle-outline"></i>
                </div>
                <div class="content">
                  <strong>No active Plan</strong>
                  <router-link :to="{ path: '/subscribe'  }">
                    click to subscribe to a plan
                  </router-link>
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Stat Cards -->
        <div class="row mb-4">
          <div class="col-lg-4 col-md-6 mb-3">
            <router-link :to="{ path: '/my-funds'}" class="text-decoration-none">
              <div class="stat-card stat-card--blue">
                <div class="stat-icon">
                  <i class="fe fe-database"></i>
                </div>
                <div>
                  <p class="stat-label">Wallet</p>
                  <h3 class="stat-value"><i class="mdi mdi-currency-ngn"></i>{{wallet.amount | numeral('0,0.00')}}</h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-md-6 mb-3">
            <router-link :to="{ path: '/my-dependents'}" class="text-decoration-none">
              <div class="stat-card stat-card--green">
                <div class="stat-icon">
                  <i class="fe fe-users"></i>
                </div>
                <div>
                  <p class="stat-label">Dependents</p>
                  <h3 class="stat-value">{{dependents.length}}</h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-md-6 mb-3">
            <router-link :to="{ path: '/subscribe'}" class="text-decoration-none">
              <div class="stat-card stat-card--purple">
                <div class="stat-icon">
                  <i class="fe fe-credit-card"></i>
                </div>
                <div>
                  <p class="stat-label">Plan</p>
                  <h3 class="stat-value" v-for="plan in myplan" v-bind:key="plan.id">{{plan.title}}</h3>
                  <p class="mb-0" v-if="myplan.length < 1">No active Subscription</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-4">
            <div class="card table-card shadow">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-users" style="font-size:13px;"></i></div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Dependents</p>
                  <small style="color:rgba(255,255,255,.7);">{{dependents.length}} dependent(s) on your account</small>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">Name</th>
                      <th class="table-th">E mail</th>
                      <th class="table-th">Phone Number</th>
                      <th class="table-th">Relationship</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="dependent in dependents" v-bind:key="dependent.id">
                      <td class="font-weight-bold">{{dependent.firstname}} {{dependent.lastname}}</td>
                      <td>{{dependent.email}}</td>
                      <td>{{dependent.phone_number}}</td>
                      <td><span class="rel-chip">{{dependent.relationShipType}}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-md-12 mb-4">
            <div class="card table-card shadow">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-alert-circle" style="font-size:13px;"></i></div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Complaints</p>
                  <small style="color:rgba(255,255,255,.7);">Your submitted complaints</small>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">Complain Number</th>
                      <th class="table-th">Title</th>
                      <th class="table-th">Type</th>
                      <th class="table-th">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="complaint in complaints" v-bind:key="complaint.id">
                      <td><span class="code-chip">122333932</span></td>
                      <td>{{complaint.title}}</td>
                      <td>{{complaint.type}}</td>
                      <td><span class="badge badge-soft-info">{{complaint.status}}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
</main>


    </div>

</template>

<script>
import Navbar from '@/views/Navbar.vue'

export default {
  components: {
     Navbar
  },
  data(){
    return{
      auth_user:"",
      dependents:"",
      myplan:"",
      wallet:"",
      complaints:"",
      user:null

    }
  },
  beforeMount(){

    this.axios.get(`/api/v1/auth/user`)
                .then(response => {
                    this.auth_user = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    getDependents(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/allDependantUser/${this.user.id}`)
                  .then(response => {
                      this.dependents = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getPlan(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/userSubscribedPlan`)
                  .then(response => {
                      this.myplan = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getComplaints(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/complaints/${this.user.id}`)
                  .then(response => {
                      this.complaints = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getWallet(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/getUserWallet`)
                  .then(response => {
                      this.wallet = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    }

  },
  created(){
    this.getDependents()
    this.getComplaints()
    this.getPlan()
    this.getWallet()
  }
}
</script>
<style lang="css" scoped>
.stat-card {
  display: flex;
  align-items: center;
  gap: 18px;
  border-radius: 14px;
  padding: 22px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
  color: #fff;
  height: 100%;
}
.stat-card--blue { background: linear-gradient(135deg, #1e3a5f, #2563eb); }
.stat-card--purple { background: linear-gradient(135deg, #4c1d95, #7c3aed); }
.stat-card--green { background: linear-gradient(135deg, #065f46, #10b981); }
.stat-card--orange { background: linear-gradient(135deg, #9a3412, #f97316); }
.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(255, 255, 255, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}
.stat-label {
  margin: 0;
  font-size: .78rem;
  text-transform: uppercase;
  letter-spacing: .05em;
  opacity: .85;
}
.stat-value {
  margin: 2px 0 0;
  font-weight: 700;
}
</style>
